import API_MAP from '../configs/url-api';
import UtilsHelper from '../utils/utils-helper';
import BaseHelper from './base-helper';

class Common extends BaseHelper {
  countUsers(props) {
    return this.request(API_MAP.COUNT_USERS, {
      method: 'GET',
      auth: 'Bearer',
      ...props,
    });
  }

  getPublicUsers(props) {
    return this.request(API_MAP.USERS + API_MAP.PUBLIC, {
      method: 'GET',
      auth: 'Bearer',
      ...props,
    });
  }

  getUserFiles(filter = {}) {
    return this.request(API_MAP.FILES, {
      method: 'GET',
      auth: 'Bearer',
      filter,
    });
  }

  getPublicUsersData(userId) {
    return this.request(`${API_MAP.USERS}/${userId}${API_MAP.PUBLIC}`, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  uploadUserFile(file) {
    return this.request(API_MAP.FILES + API_MAP.INSERT, {
      method: 'POST',
      auth: 'Bearer',
      body: file,
    });
  }

  uploadVideoFileUrl(data = {}) {
    return this.request(API_MAP.FILES + API_MAP.INSERT_INTERNAL_VIDEO, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  updateUserFile(fileId, fileName) {
    return this.request(`${API_MAP.FILES}/${fileId}`, {
      method: 'PUT',
      auth: 'Bearer',
      body: {
        fileName,
      },
    });
  }

  getVideoRecords(videoRecordId = null, filter) {
    const url = API_MAP.VIDEO_RECORDS + (videoRecordId ? `/${videoRecordId}` : '');
    return this.request(url, {
      method: 'GET',
      auth: 'Bearer',
      perPage: 100,
      filter,
    });
  }

  getAdminVideoRecords(filter = {}) {
    return this.request(`${API_MAP.VIDEO_RECORDS}/admin-list`, {
      method: 'GET',
      auth: 'Bearer',
      filter,
    });
  }

  adminRemoveRecordsByType(data) {
    return this.request(`${API_MAP.VIDEO_RECORDS}/remove-all`, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  adminRemoveRecordById(recordId) {
    return this.request(`${API_MAP.VIDEO_RECORDS}/${recordId}`, {
      method: 'DELETE',
      auth: 'Bearer',
    });
  }

  getContacts() {
    return this.request(API_MAP.GET_CONTACTS, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  getFavoriteContacts() {
    return this.request(API_MAP.GET_FAVORITE_CONTACTS, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  getRecentContacts() {
    return this.request(API_MAP.GET_RECENT_CONTACTS, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  getUsersList(params) {
    return this.request(API_MAP.USERS, {
      method: 'GET',
      auth: 'Bearer',
      ...params,
    });
  }

  getUsersPublicList(filter = {}) {
    const filterString = UtilsHelper.serialize(filter, '?');
    const url = API_MAP.USERS + API_MAP.PUBLIC + filterString;

    return this.request(url, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  inviteEmailVideosession(data) {
    return this.request(API_MAP.VIDEOSESSION + API_MAP.INVITE_EMAIL, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  inviteOnlineVideosession(data) {
    return this.request(API_MAP.VIDEOSESSION + API_MAP.INVITE_ONLINE, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  addUserToContacts(id, userId) {
    return this.request(`${API_MAP.USERS}/${id}${API_MAP.CONTACTS}/${userId}`, {
      method: 'PUT',
      auth: 'Bearer',
    });
  }

  changeVideoRecordType(type, videoRecordId) {
    return this.request(`${API_MAP.VIDEO_RECORDS}/${videoRecordId}`, {
      method: 'PATCH',
      auth: 'Bearer',
      body: {
        type,
      },
    });
  }

  deleteVideoRecord(videoRecordId) {
    return this.request(`${API_MAP.VIDEO_RECORDS}/${videoRecordId}/remove`, {
      method: 'POST',
      auth: 'Bearer',
    });
  }

  shareEmailVideoRecord(data, videoRecordId) {
    return this.request(`${API_MAP.VIDEO_RECORDS}/${videoRecordId}/share/email`, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  shareUserPortfolio(data, userId) {
    return this.request(`${API_MAP.USERS}/${userId}${API_MAP.SHARE_PORTFOLIO}`, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  shareVideoRecordToParticipants(videoRecordId) {
    return this.request(`${API_MAP.VIDEO_RECORDS}/${videoRecordId}/share/participants`, {
      method: 'POST',
      auth: 'Bearer',
    });
  }

  createSupport(data, isFormData) {
    const body = isFormData ? data : {...data};
    return this.request(API_MAP.SUPPORTS, {
      method: 'POST',
      auth: 'Bearer',
      body,
    });
  }

  subscribeToNews(email) {
    return this.request(API_MAP.USERS + API_MAP.SUBSCRIBE_NEWS, {
      method: 'POST',
      auth: 'Bearer',
      body: {
        email,
      },
    });
  }

  employerSubscribeToNews(data) {
    return this.request(API_MAP.USERS + API_MAP.EMPLOYER_SUBSCRIBE_NEWS, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  getInstruction(id) {
    return this.request(`${API_MAP.INSTRUCTIONS}${id ? `/${id}` : ''}`, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  getInstructions() {
    return this.request(API_MAP.INSTRUCTIONS, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  createInstruction(data) {
    return this.request(API_MAP.INSTRUCTIONS, {
      method: 'POST',
      auth: 'Bearer',
      body: data,
    });
  }

  updateInstruction(data, id) {
    return this.request(`${API_MAP.INSTRUCTIONS}${id ? `/${id}` : ''}`, {
      method: 'PATCH',
      auth: 'Bearer',
      body: data,
    });
  }

  useResourcesOfDemo(id, hoursOfAccess) {
    const url = `${API_MAP.TARIFFS}/${id}/use-demo-resources`;

    return this.request(url, {
      method: 'POST',
      auth: 'Bearer',
      body: {
        hoursOfAccess,
      },
    });
  }

  getAllTransactions() {
    return this.request(`${API_MAP.TRANSACTIONS}?perPage=10000`, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  refundTransaction(refundData, transactionId, isFormData) {
    const body = isFormData ? refundData : {...refundData};
    return this.request(`${API_MAP.TRANSACTIONS}/${transactionId}${API_MAP.REFUND}`, {
      method: 'POST',
      auth: 'Bearer',
      body,
    });
  }

  updateTransaction(transactionId, data = {}) {
    return this.request(`${API_MAP.TRANSACTIONS}/${transactionId}`, {
      method: 'PATCH',
      auth: 'Bearer',
      body: data,
    });
  }

  sendFlashphonerErrorLogs(data = {}) {
    return this.request(API_MAP.LOGS, {
      method: 'POST',
      auth: 'Basic',
      body: {
        ...data,
        level: 30,
        category: 2,
      },
    });
  }
}

export default new Common();
